import { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";

// Confirmação SIM/NÃO em modal do sistema (substitui o window.confirm nativo).
function Confirmar({ texto, onFim }: { texto: string; onFim: (v: boolean) => void }) {
  const simRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    setTimeout(() => simRef.current?.focus(), 0);
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        onFim(false);
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [onFim]);
  return (
    <div className="msg-modal-bg" role="alertdialog" aria-modal="true">
      <div className="msg-modal msg-aviso">
        <div className="msg-modal-titulo">
          <span className="msg-modal-ico">❓</span>Confirmação
        </div>
        <div className="msg-modal-texto">{texto}</div>
        <div className="msg-modal-acoes">
          <button className="btn-secundario" onClick={() => onFim(false)}>
            Não
          </button>
          <button ref={simRef} className="btn-acao" onClick={() => onFim(true)}>
            Sim
          </button>
        </div>
      </div>
    </div>
  );
}

export function confirmar(texto: string): Promise<boolean> {
  const antes = document.activeElement as HTMLElement | null;
  const host = document.createElement("div");
  document.body.appendChild(host);
  const root = createRoot(host);
  return new Promise((resolve) => {
    const fim = (v: boolean) => {
      root.unmount();
      host.remove();
      setTimeout(() => antes?.focus?.(), 0);
      resolve(v);
    };
    root.render(<Confirmar texto={texto} onFim={fim} />);
  });
}
